import api from '@/api'
import lodash from 'lodash'

const controller = {
  createOne: (keys) => ({
    entity: 'equipment_ledger',
    title: '',
    type: '',
    informations: keys.reduce((a, b) => { a[b] = []; return a }, {}),
    factors: []
  })
}

export default {
  namespaced: true,
  state: {
    list: [],
    types: [],
    informationKeys: [
      'Factory',
      'Grade',
      'Code',
      'Manufacture',
      'Products',
      'Price',
      'Year',
      'Tack Time',
      'Utilitie',
      'Index'
    ]
  },
  mutations: {
    update (state, equipment) {
      var o = lodash.find(state.list, {_id: equipment._id})
      lodash.extend(o, equipment)
    },
    delete (state, equipment) {
      const i = lodash.findIndex(state.list, {_id: equipment._id})
      state.list.splice(i, 1)
    }
  },
  actions: {
    async load (context) {
      const res = await api.postBIZ('/api/content/find', {selector: {entity: 'equipment_ledger'}, limit: 9999})
      context.state.list = res.data.filter(e => e.type === '' || e.title !== e.type)
      context.state.types = res.data.map(l => l.type).filter((l, i, self) => l !== '' && self.indexOf(l) === i)
    },
    async appendEquipment (context, equipment) {
      const one = lodash.extend(controller.createOne(context.state.informationKeys), equipment)
      lodash.extend(one, {author: context.rootState.user.data._id})
      await api.putBIZ('/api/content', [{content: one}])
      await context.dispatch('load')
    },
    async delete (context, equipment) {
      const uri = encodeURIComponent(`${equipment._id}?rev=${equipment._rev}`)
      await api.deleteBIZ(`/api/content?uri=${uri}`)
      context.commit('delete', equipment)
    },
    async updateAndSave (context, equipment) {
      lodash.extend(equipment, {author: context.rootState.user.data._id})
      const res = await api.putBIZ('/api/content', {uri: equipment._id, content: equipment})
      equipment._rev = (res.data.shift() || {}).rev
      context.commit('update', equipment)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/equipments.js